import api from '@/api'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async update_about(state, about) {
      await api({
        method: "POST",
        url: `/account/admin/application`,
        data: {
          about: about
        }
      })
    }
  },
}
